module.exports = __webpack_public_path__ + "img/CAL-IEC-charge.fdf6bfef.webp";